import { useRef, useState } from 'react';
import socialFacebook from 'assets/svg/soical_facebook.svg';
import socialInstagram from 'assets/svg/social_instagram.svg';
import socialX from 'assets/svg/social_x.svg';
import facebookIcon from 'assets/icons/facebook_icon.png';
import tokenIcon from 'assets/icons/token_icon.png';
import { useApp } from 'context/AppContext';
import { useAuth } from 'context/AuthContext';
import { Navigate } from 'react-router-dom';
import { Fotter, Loader } from 'components';
import { Icon } from 'styles/AppStyles';
import {
  Container,
  Box,
  Logo,
  Content,
  TokenLogin,
  BackIcon,
  Title,
  SubTitle,
  MethodButtons,
  Button,
  LoginButton,
  BBumLogo,
  SocialButtons,
  Form,
  Input,
  Label,
  WheresMyCode,
} from './Styles';
import { useWindowDimensions } from 'hooks';
import { currentGameConfig, currentContentConfig } from 'utils/handleCurrentContentConfig';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isTokenSelected, setIsTokenSelected] = useState(false);
  const [tokenCode, setTokenCode] = useState('');
  const [isError, setIsError] = useState(false);

  const { setUserData, setDailyBonusTime, openModal } = useApp();
  const { signin, user } = useAuth();
  const isAnimation = useRef(false);

  const { width } = useWindowDimensions();
  const { socials } = currentGameConfig.info;

  const socialIcons = {
    facebook: socialFacebook,
    instagram: socialInstagram,
    x: socialX,
  };

  const handleLogin = async () => {
    setIsLoading(true);
    const data = await signin(tokenCode);
    setIsLoading(false);
    if (data) {
      const { plr, dBCn } = data;
      setUserData(plr);
      dBCn && setDailyBonusTime(dBCn);
    } else {
      setIsError(true);
    }
  };

  const handleInputChanged = event => {
    const { value } = event.target;
    setIsError(false);
    setTokenCode(value.replace(/\s/g, ''));
  };

  const handlenTokenLogin = () => {
    setIsTokenSelected(true);
    isAnimation.current = true;
  };

  const handleBackIcon = () => {
    setIsError(false);
    setTokenCode('');
    setIsTokenSelected(false);
  };

  if (user) return <Navigate to="/" replace />;

  return (
    <>
      <Container>
        <Box>
          <Logo />
          <Content>
            {isTokenSelected ? (
              <>
                <BackIcon
                  {...(!isLoading && { onClick: handleBackIcon })}
                  $disabled={isLoading}
                  $withTransition
                />
                <TokenLogin>
                  <Title>Log in with code</Title>
                  <Box style={{ gap: '1.5rem' }}>
                    <SubTitle>Please enter the code from your app settings to access the store</SubTitle>
                    <Form>
                      <Input
                        value={tokenCode}
                        placeholder="Code"
                        onChange={handleInputChanged}
                        onKeyDown={({ key }) => key === 'Enter' && tokenCode && handleLogin()}
                      />
                      <Label $isError={isError}>Code</Label>
                      {isError && (
                        <SubTitle style={{ marginTop: '0.3rem', color: 'red' }}>
                          Invalid code. Please try again
                        </SubTitle>
                      )}
                    </Form>
                    <LoginButton color="green" onClick={handleLogin} disabled={isLoading || !tokenCode}>
                      <Icon
                        src={tokenIcon}
                        width={25}
                        style={{ position: width > 400 ? 'absolute' : 'unset', left: '15px' }}
                      />
                      Log in {isLoading && <Loader size={16} width={3} />}
                    </LoginButton>
                    <WheresMyCode onClick={() => openModal({ modal: 'WheresMyCode' })}>
                      Where’s my code?
                    </WheresMyCode>
                  </Box>
                </TokenLogin>
              </>
            ) : (
              <MethodButtons $isAnimation={isAnimation.current}>
                <Button color="blue" onClick={handleLogin} disabled={isLoading} $isLoading={isLoading}>
                  <Icon src={facebookIcon} />
                  Log in with Facebook {isLoading && <Loader size={16} width={3} />}
                </Button>
                {/* Need to add the condition for button above*/}
                {currentContentConfig.isLoginWithCode && (
                  <Button color="darkBlue" onClick={handlenTokenLogin} disabled={isLoading}>
                    <Icon src={tokenIcon} />
                    Log in with code
                  </Button>
                )}
              </MethodButtons>
            )}
          </Content>
        </Box>
        <BBumLogo />
        <SocialButtons $isError={isError}>
          {Object.entries(socials).map(([key, url]) => (
            <Icon key={key} src={socialIcons[key]} $withTransition onClick={() => window.open(url)} />
          ))}
        </SocialButtons>
      </Container>
      <Fotter />
    </>
  );
};

export default Login;
